import {Typography} from 'components/Typography';
import {FC, useMemo} from 'react';
import style from './style.module.scss';

interface IProps {
    title: string;
    value: number;
}

export const DetailedCharacteristicsTasteItem: FC<IProps> = ({title, value}) => {
    const progressLineStyle = useMemo(() => {
        return {width: `${value * 20}%`};
    }, [value]);

    return (
        <div>
            <div>
                <Typography variant={'label-14-r-fluid'}>{title}</Typography>
                <Typography className={style.value} variant={'label-16-m'}>
                    {value}
                </Typography>
            </div>
            <div className={style.progressBlock}>
                <div className={style.progressLine} style={progressLineStyle} />
            </div>
        </div>
    );
};
